
import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '../views/auth/LoginView.vue'
import Admin from '../views/admin/AdminView.vue'
import Perfil from '../views/admin/PerfilView.vue'
import AppLayout from '../views/AppLayout.vue'
//import Inicio from "../views/InicioView.vue"
//import HomeView from '../views/HomeView.vue'
import AboutView from '../views/HomeView.vue'
//import CategoriaComentarioView from '../views/sistema/CategoriaComentarioView.vue'
import ClienteLoginView from "../views/ClienteLoginView.vue";
import ClienteRegistroView from "../views/ClienteRegistroView.vue";
import ClientePerfilView from "../views/ClientePerfilView.vue";

// import Nosotros from '@/views/Nosotros.vue'
// import Servicios from '@/views/Servicios.vue'
// import Productos from '@/views/Productos.vue'
// import Contacto from '@/views/Contacto.vue'


import { canNavigate } from '../casl/routeProtection'
import { getUserData, redireccionPorRol } from '../casl/utils'
import { loadRuntimeContext } from '../tenancy/runtimeContext'
import { loadSiteConfig, siteState } from '../site/siteConfig'

Vue.use(VueRouter)


const routes = [
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
    // Quita requireAuth para que sea público
    meta: {
      //requireAuth: true,  <--- quitar esto
      resource: 'auth',
      action: 'show'
    }

  },

  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
    meta: {
      resource: 'auth',
      action: 'show'
    }
  },

  {
    path: '/nosotros',
    name: 'nosotros',
    component: () => import('../views/NosotrosView.vue'),
    // Quita requireAuth para que sea público
    meta: {
      //requireAuth: true,  <--- quitar esto
      resource: 'auth',
      action: 'show'
    }

  },
  {
    path: '/servicios',
    name: 'servicios',
    component: () => import('../views/ServiciosView.vue'),
    // Quita requireAuth para que sea público
    meta: {
      //requireAuth: true,  <--- quitar esto
      resource: 'auth',
      action: 'show'
    }

  },
  {
    path: '/blog',
    name: 'blog',
    component: () => import('../views/BlogView.vue'),
    meta: { resource: 'auth', action: 'show' }
  },
  {
    path: '/blog/:slug',
    name: 'blog-article',
    component: () => import('../views/ArticleView.vue'),
    meta: { resource: 'auth', action: 'show' }
  },
  {
    path: '/productos',
    name: 'productos',
    component: () => import('../views/ProductosView.vue'),
    // Quita requireAuth para que sea público
    meta: {
      //requireAuth: true,  <--- quitar esto
      resource: 'auth',
      action: 'show'
    }

  },

  {
    path: "/pedidos",
    name: "pedidos",
    component: () => import("../views/PedidosView.vue"),
    meta: {
      requiereCliente: true,
      commerceOnly: true,
    },
  },











{
  path: "/login",
  name: "cliente-login",
  component: ClienteLoginView,
  meta: {
    guestCliente: true,
    commerceOnly: true,
  },
},
{
  path: "/registro",
  name: "cliente-registro",
  component: ClienteRegistroView,
  meta: {
    guestCliente: true,
    commerceOnly: true,
  },
},
{
  path: "/auth/google/callback",
  name: "google-callback",
  component: () =>
    import("../views/GoogleCallbackView.vue"),
  meta: { commerceOnly: true },
},
{
  path: "/mi-cuenta",
  name: "cliente-perfil",
  component: ClientePerfilView,
  meta: {
    requiereCliente: true,
    commerceOnly: true,
  },
},

















  {
    path: '/productos/:id',
    name: 'editarProducto',
    component: () => import('../views/ProductoEdit.vue'), // o el componente que uses
    // Quita requireAuth para que sea público
    meta: {
      //requireAuth: true,  <--- quitar esto
      resource: 'auth',
      action: 'show'
    }
  },

  {
    path: '/carrito',
    name: 'carrito',
    component: () => import('../views/CarritoView.vue'),
    // Quita requireAuth para que sea público
    meta: {
      commerceOnly: true,
      //requireAuth: true,  <--- quitar esto
      resource: 'auth',
      action: 'show'
    }

  },

  {
    path: '/checkout',
    name: 'Checkout',
    component: () => import('../views/CheckoutView.vue'),
    // Quita requireAuth para que sea público
    meta: {
      commerceOnly: true,
      //requireAuth: true,  <--- quitar esto
      resource: 'auth',
      action: 'show'
    }

  },
  {
    path: '/contacto',
    name: 'contacto',
    component: () => import('../views/ContactoView.vue'),
    // Quita requireAuth para que sea público
    meta: {
      //requireAuth: true,  <--- quitar esto
      resource: 'auth',
      action: 'show'
    }

  },

  {
    path: '/admin/login',
    name: 'Login',
    component: Login,
    meta: {
      redirectIfAuth: true,
      resource: 'auth',
      action: 'show'
    }
  },
  {
    path: '/admin',
    component: AppLayout,
    meta: { 
      requireAuth: true,
      resource: 'auth',
      action: 'show'
    },
    children: [

      // {
      //   path: 'no-autorizado',
      //   name: 'NoAutorizadoAdmin',
      //   component: () => import('../views/errors/NoAutorizado.vue')
      // },
      // {
      //   path: 'no-autorizado',
      //   name: 'NoAutorizado',
      //   component: () => import('../views/errors/NoAutorizado.vue'),
      //   // meta: {
      //   //   resource: 'auth',
      //   //   action: 'show'
      //   // }
      // },
      // {
      //   path: 'fichas',
      //   name: 'fichas',
      //   component: () => import('../views/sistema/FichaGrillaView.vue'),
      //   meta: { 
      //     requireAuth: true,
      //     resource: 'seguimiento',
      //     action: 'index'
      //   },
      // },
      // {
      //   path: 'alerta',
      //   name: 'Alerta',
      //   component: () => import('../views/sistema/AlertaView.vue'),
      //   meta: { 
      //       requireAuth: true,
      //       resource: 'seguimiento',
      //       action: 'index'
      //   },
      // },
      // {
      //   path: 'seguimiento',
      //   name: 'seguimiento',
      //   component: () => import('../views/sistema/SeguimientoView.vue'),
      //   meta: { 
      //     requireAuth: true,
      //     resource: 'seguimiento',
      //     action: 'index'
      //   },
      // },

      // Este se cambió de Home a about
      {
        path: 'about',
        name: 'about',
        component: AboutView,
        meta: {
          requireAuth: true,
          resource: 'auth',
          action: 'show'
        }
      },
      {
        path: '',
        name: 'admin',
        component: Admin,
        redirect: '/admin/login'
      },
      {
        path: 'perfil',
        name: 'perfil',
        component: Perfil,
        meta: {
          requireAuth: true,
          resource: 'auth',
          action: 'show'
        },
      },
      {
        path: 'configuracion-sitio',
        name: 'configuracion-sitio',
        component: () => import('../views/admin/SiteConfigView.vue'),
        meta: {
          requireAuth: true,
          resource: 'auth',
          action: 'show'
        },
      },
      {
        path: 'canales',
        name: 'canales',
        component: () => import('../views/admin/SalesChannelsView.vue'),
        meta: {
          requireAuth: true,
          resource: 'producto',
          action: 'index'
        },
      },
      {
        path: 'publicaciones',
        name: 'publicaciones',
        component: () => import('../views/admin/ProductPublicationsView.vue'),
        meta: {
          requireAuth: true,
          resource: 'producto',
          action: 'index'
        },
      },
      {
        path: 'ventas',
        name: 'ventas-pedidos',
        component: () => import('../views/admin/OrdersAdminView.vue'),
        meta: {
          requireAuth: true,
          resource: 'producto',
          action: 'index'
        },
      },
      {
        path: 'ventas-canales',
        name: 'ventas-canales',
        component: () => import('../views/admin/ChannelOrdersView.vue'),
        meta: {
          requireAuth: true,
          resource: 'producto',
          action: 'index'
        },
      },
      {
        path: 'empresa',
        name: 'empresa',
        component: () => import('../views/admin/TenantAdministrationView.vue'),
        meta: {
          requireAuth: true,
          resource: 'auth',
          action: 'show',
          tenantManagement: true,
          platformContext: true
        },
      },
      {
        path: 'empresas',
        name: 'empresas-plataforma',
        component: () => import('../views/admin/PlatformTenantsView.vue'),
        meta: {
          requireAuth: true,
          resource: 'auth',
          action: 'show',
          platformContext: true
        },
      },
      {
        path: 'contenido',
        name: 'contenido',
        component: () => import('../views/admin/ContentManagerView.vue'),
        meta: {
          requireAuth: true,
          resource: 'producto',
          action: 'index'
        },
      },
      {
        path: 'permiso',
        name: 'permiso',
        component: () => import('../views/admin/role/PermisoView.vue'),
        meta: { 
          requireAuth: true,
          resource: 'permiso',
          action: 'index'
        },
      },
      {
        path: 'usuario',
        name: 'usuario',
        component: () => import('../views/admin/usuario/UsuarioView.vue'),
        meta: { 
          requireAuth: true,
          resource: 'user',
          action: 'index'
        },
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('../views/admin/role/RoleView.vue'),
        meta: { 
          requireAuth: true,
          resource: 'role',
          action: 'index'
        },
      },

      {
        path: 'producto',
        name: 'producto',
        component: () => import('../views/sistema/ProductoView.vue'),
        meta: { 
          requireAuth: true,
          resource: 'producto',
          action: 'index'
        },
      },
      {
        path: '/producto/:id',
        name: 'stockProducto',
        component: () => import('../views/sistema/ProductoStock.vue'), // o el componente que uses
        // Quita requireAuth para que sea público
        meta: {
          //requireAuth: true,  <--- quitar esto
          resource: 'producto',
          action: 'index'
        }
      },
      {
        path: 'categoria',
        name: 'categoria',
        component: () => import('../views/sistema/CategoriaView.vue'),
        meta: { 
          requireAuth: true,
          resource: 'categoria',
          action: 'index'
        },
      },
      // {
      //   path: 'carga',
      //   name: 'carga',
      //   component: () => import('../views/admin/carga/CargaView.vue'),
      //   meta: { 
      //     requireAuth: true,
      //     resource: 'carga',
      //     action: 'index'
      //   },
      // },
      // {
      //   path: 'categoriaComentario',
      //   name: 'categoriaComentario',
      //   component: () => import('../views/sistema/CategoriaComentarioView.vue'),
      //   meta: { 
      //     requireAuth: true,
      //     resource: 'categoriaComentario',
      //     action: 'index'
      //   },
      // },
      
    ]
  },
  {
    path: '/recuperar-password',
    name: 'RecuperarPassword',
    component: () => import('../views/auth/RecuperarPassword.vue'),
    meta: {
      resource: 'auth',
      action: 'show'
    }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('../views/auth/ResetPassword.vue'),
    meta: {
      resource: 'auth',
      action: 'show'
    }
  },
  {
    path: '/no-autorizado',
    name: 'NoAutorizado',
    component: () => import('../views/errors/NoAutorizado.vue'),
    meta: {
      resource: 'auth',
      action: 'show'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/errors/NotFound.vue'),
  }
]




// const routes = [
//   {
//     path: '/',
//     name: 'home',
//     component: HomeView
//   },
//   {
//     path: '/about',
//     name: 'about',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
//   },
//   {
//     path: '/login',
//     name: 'login',
//     component: Login,
//     meta: {
//       redirectIfAuth: true,
//       //resource: 'auth',
//       //action: 'show'
//     }
//   },
//   {
//     path: '/admin',
//     name: 'admin',
//     component: AdminView,
//     meta: {
//             requireAuth: true
//           }
//     // path: '/admin',
//     // component: AppLayout,
//     // meta: { 
//     //   requireAuth: true,
//     //   resource: 'admin',
//     //   action: 'index'
//     // },
//     // children: [
//     //   {
//     //     path: '',
//     //     name: 'admin',
//     //     component: Admin,
//     //     meta: {
//     //       requireAuth: true,
//     //       resource: 'admin',
//     //       action: 'index'
//     //     },
//     //   },
//       // {
//       //   path: 'perfil',
//       //   name: 'perfil',
//       //   component: Perfil,
//       //   meta: {
//       //     requireAuth: true,
//       //     resource: 'perfil',
//       //     action: 'index'
//       //   },
//       // },
//       // {
//       //   path: 'usuario',
//       //   name: 'usuario',
//       //   component: () => import('../views/admin/usuario/Usuario.vue'),
//       //   meta: { 
//       //     requireAuth: true,
//       //     resource: 'user',
//       //     action: 'index'
//       //   },
//       // },
//       // {
//       //   path: 'role',
//       //   name: 'role',
//       //   component: () => import('../views/admin/role/Role.vue'),
//       //   meta: { 
//       //     requireAuth: true,
//       //     resource: 'role',
//       //     action: 'index'
//       //   },
//       // },
//       // {
//       //   path: 'role/:id',
//       //   name: 'roleEdit',
//       //   component: () => import('../views/admin/role/RoleEdit.vue'),
//       //   meta: { 
//       //     requireAuth: true,
//       //     resource: 'role',
//       //     action: 'update'
//       //   },
//       // },
//       // {
//       //   path: 'permiso',
//       //   name: 'Permiso',
//       //   component: () => import('../views/admin/role/Permiso.vue'),
//       //   meta: { 
//       //     requireAuth: true,
//       //     resource: 'permiso',
//       //     action: 'index'
//       //   },
//       // }
//     // ]
//   }
  
// ]

// const router = new VueRouter({
//   routes
// })
const router = new VueRouter({
  mode: 'history', // Habilita el modo de historial de HTML5
  base: process.env.BASE_URL,
  routes
})









// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem("token");
//   const hasPermission = canNavigate(to);

//   console.log("to", to.fullPath);
//   console.log("Token:", token);
//   console.log("canNavigate:", hasPermission);

//   if (to.meta.redirectIfAuth && token) {
//     // Está logueado y quiere ir al login o a una ruta que no debería ver si ya está autenticado
//     const userData = getUserData();
//     return next(redireccionPorRol(userData?.roles?.[0]?.nombre));
//   }

//   if (to.meta.requireAuth) {
//     // Ruta protegida: requiere login
//     if (!token) {
//       return next({ path: '/admin/login' });
//     }

//     if (!hasPermission) {
//       return next({ path: '/no-autorizado' });
//     }

//     // Está logueado y tiene permiso
//     return next();
//   }

//   // Ruta pública
//   return next();
// });





// ESTE ES EL QUE ESTABA 20251109:

// router.beforeEach((to, from, next) => {
//   let token = localStorage.getItem("token");

//   const hasPermission = canNavigate(to);

//   console.log("to", to);
//   console.log("toPATH", to.path);
//   console.log("canNavigate de index, haspermission: ", hasPermission);

//   if (hasPermission == false) {

//     console.log("ENTRA EN HASPERMISSION FALSE");
//     // Si intento acceder a /admin (o alguna ruta hija) y no estoy logueado...
//     if (to.path.startsWith('/admin')) {
//       if (!token) {
//         // No logueado, va a login
//         return next({ path: '/admin/login' });
//       } else {

//         console.log("ESTA LOGUEADO");
//         // Logueado pero sin permisos, va a no autorizado o perfil
//         // Acá podrías hacer:
//         if(hasPermission == true){
//           console.log("TIENE PERMISO");
//           return next({ path: '/admin/perfil' });

//         }else{
//           console.log("NO TIENE PERMISO");
//           window.location.href = "/no-autorizado"

//         }
//         //     return next();

//         // o si querés que vaya a perfil:
//         // return next({ path: '/admin/perfil' });
//       }
//     }
//     // Para otras rutas que no tienen permiso, mandá a /about o donde quieras
//     return next({ path: '/home' });

//     //       return next({ path: '/no-autorizado' });


//   } else {
//     console.log("Tiene canNavigate");
//     console.log("ENTRA EN HASPERMISSION true");

//     //http://localhost:8080/
//     //http://localhost:8080/home



//     if (to.meta.redirectIfAuth && token) {
//       const userData = getUserData();
//       console.log(userData.roles[0].nombre);
//       return next(redireccionPorRol(userData ? userData.roles[0].nombre : null));
//     }
//     return next();
//   }
// });


// ESTE ES EL QUE ANDABA EL 20260723, y lo cambié por lo nuevo de chatGPT

// router.beforeEach((to, from, next) => {

//   let token = localStorage.getItem("token");

//   const hasPermission = canNavigate(to);

//   console.log("to", to);
//   console.log("toPATH", to.path);
//   console.log("canNavigate de index, haspermission: ", hasPermission);

//   if (hasPermission == false) {

//     console.log("ENTRA EN HASPERMISSION FALSEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEE");
//     // Si intento acceder a /admin (o alguna ruta hija) y no estoy logueado...
//     if (to.path.startsWith('/admin')) {
//       if (!token) {
//         // No logueado, va a login
//         return next({ path: '/admin/login' });
//       } else {

//         console.log("ESTA LOGUEADO");
//         // Logueado pero sin permisos, va a no autorizado o perfil
//         // Acá podrías hacer:
//         if(hasPermission == true){
//           console.log("TIENE PERMISO");
//           return next({ path: '/admin/perfil' });

//         }else{
//           console.log("NO TIENE PERMISO");
//           window.location.href = "/no-autorizado"

//         }
//         //     return next();

//         // o si querés que vaya a perfil:
//         // return next({ path: '/admin/perfil' });
//       }
//     }
//     // Para otras rutas que no tienen permiso, mandá a /about o donde quieras
//     //return next({ path: '/home' });

//     //       return next({ path: '/no-autorizado' });


//   } else {
//     console.log("Tiene canNavigate");
//     console.log("ENTRA EN HASPERMISSION true");

//     //http://localhost:8080/
//     //http://localhost:8080/home



//     if (to.meta.redirectIfAuth && token) {
//       const userData = getUserData();
//       console.log(userData.roles[0].nombre);
//       return next(redireccionPorRol(userData ? userData.roles[0].nombre : null));
//     }
//     return next();
//   }
// });




// Lo nuevo

// sexto

//NUEVO 20260726
// router.beforeEach((to, from, next) => {

//   /*
//    * RUTAS DE CLIENTES
//    *
//    * Se resuelven antes de entrar en la lógica de permisos
//    * del administrador. No modifican CASL, los roles ni el
//    * token administrativo.
//    */

//   const clienteToken = localStorage.getItem("cliente_token");

//   if (to.meta.requiereCliente) {
//     if (!clienteToken) {
//       return next({
//         name: "cliente-login",
//         query: {
//           redirect: to.fullPath,
//         },
//       });
//     }

//     return next();
//   }

//   if (to.meta.guestCliente) {
//     if (clienteToken) {
//       return next({
//         name: "cliente-perfil",
//       });
//     }

//     return next();
//   }

//   /*
//    * LÓGICA ADMINISTRATIVA ORIGINAL
//    */

//   let token = localStorage.getItem("token");

//   const hasPermission = canNavigate(to);

//   console.log("to", to);
//   console.log("toPATH", to.path);
//   console.log(
//     "canNavigate de index, haspermission: ",
//     hasPermission
//   );

//   if (hasPermission == false) {

//     console.log(
//       "ENTRA EN HASPERMISSION FALSEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEE"
//     );

//     // Si intento acceder a /admin (o alguna ruta hija)
//     // y no estoy logueado...
//     if (to.path.startsWith("/admin")) {
//       if (!token) {
//         // No logueado, va a login
//         return next({
//           path: "/admin/login",
//         });
//       } else {

//         console.log("ESTA LOGUEADO");

//         // Logueado pero sin permisos,
//         // va a no autorizado o perfil
//         if (hasPermission == true) {
//           console.log("TIENE PERMISO");

//           return next({
//             path: "/admin/perfil",
//           });
//         } else {
//           console.log("NO TIENE PERMISO");

//           window.location.href =
//             "/no-autorizado";

//           return;
//         }
//       }
//     }

//   } else {
//     console.log("Tiene canNavigate");
//     console.log("ENTRA EN HASPERMISSION true");

//     if (to.meta.redirectIfAuth && token) {
//       const userData = getUserData();

//       console.log(userData.roles[0].nombre);

//       return next(
//         redireccionPorRol(
//           userData
//             ? userData.roles[0].nombre
//             : null
//         )
//       );
//     }

//     return next();
//   }
// });



router.beforeEach(async (to, from, next) => {
  const centralPublicRoutes = ['/admin/login', '/recuperar-password', '/reset-password', '/no-autorizado'];
  const isAllowedOnCentral = to.path.startsWith('/admin') || centralPublicRoutes.includes(to.path);
  let isPlatformContext = false;

  try {
    const runtimeContext = await loadRuntimeContext();
    isPlatformContext = runtimeContext.scope === 'platform';
    if (runtimeContext.scope === 'tenant' && runtimeContext.tenant?.slug) {
      localStorage.setItem('active_tenant_slug', runtimeContext.tenant.slug);
    }
  } catch (_) {
    // La API mostrará el error correspondiente; el router no inventa un contexto.
  }

  if (isPlatformContext && !isAllowedOnCentral) {
    const userData = getUserData();
    return next({
      path: localStorage.getItem('token') && userData?.is_platform_admin
        ? '/admin/empresas'
        : '/admin/login',
    });
  }

  if (!isPlatformContext && to.matched.some(route => route.meta.platformContext)) {
    return next({ path: '/admin/perfil' });
  }

  if (!isPlatformContext && to.matched.some(route => route.meta.commerceOnly)) {
    try {
      await loadSiteConfig();
      if (siteState.data.site?.commerce_mode !== 'online') {
        return next({ path: '/productos' });
      }
    } catch (_) {
      // La vista conserva el manejo normal de errores si la configuración no responde.
    }
  }

  /*
   * AUTENTICACIÓN DE CLIENTES
   */

  const clienteToken =
    localStorage.getItem("cliente_token");

  if (to.meta.requiereCliente) {
    if (!clienteToken) {
      return next({
        name: "cliente-login",
        query: {
          redirect: to.fullPath,
        },
      });
    }

    return next();
  }

  if (to.meta.guestCliente) {
    if (clienteToken) {
      return next({
        name: "cliente-perfil",
      });
    }

    return next();
  }

  /*
   * El callback debe poder abrirse antes de que exista
   * cliente_token, porque justamente ahí se guarda.
   */
  if (to.name === "google-callback") {
    return next();
  }

  /*
   * AUTENTICACIÓN ADMINISTRATIVA
   */

  const token = localStorage.getItem("token");

  if (to.matched.some(route => route.meta.tenantManagement)) {
    const userData = getUserData();
    if (!token) return next({ path: "/admin/login" });
    if (!userData?.can_manage_tenant) return next({ path: "/no-autorizado" });
  }

  const hasPermission = canNavigate(to);

  console.log("to", to);
  console.log("toPATH", to.path);
  console.log(
    "canNavigate de index, haspermission: ",
    hasPermission
  );

  if (hasPermission === false) {
    if (to.path.startsWith("/admin")) {
      if (!token) {
        return next({
          path: "/admin/login",
        });
      }

      return next({
        path: "/no-autorizado",
      });
    }

    /*
     * Todas las rutas públicas continúan normalmente.
     */
    return next();
  }

  if (to.meta.redirectIfAuth && token) {
    const userData = getUserData();

    if (userData?.is_platform_admin && isPlatformContext) {
      return next({ path: '/admin/empresas' });
    }

    return next(
      redireccionPorRol(
        userData
          ? userData.roles[0].nombre
          : null
      )
    );
  }

  return next();
});



















// primer intento 20251109

// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem("token");
//   const hasPermission = canNavigate(to);

//   if (!hasPermission) {
//     console.log("SIN PERMISOS");

//     if (to.path.startsWith('/admin')) {
//       if (!token) {
//         // No logueado → al login
//         return next({ path: '/admin/login' });
//       } else {
//         // Logueado pero sin permisos → al no autorizado
//         return next({ path: '/no-autorizado' });
//       }
//     }

//     // Si es otra ruta pública sin permisos → al home
//     return next({ path: '/home' });
//   }

//   // Si ya está logueado y quiere ir al login
//   if (to.meta.redirectIfAuth && token) {
//     const userData = getUserData();
//     return next(redireccionPorRol(userData?.roles?.[0]?.nombre));
//   }

//   return next();
// });


// segundo

// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem("token");
//   const hasPermission = canNavigate(to);

//   // helper local que cierra sobre 'to' y 'next'
//   const safeRedirect = (target) => {
//     if (to.path !== target) {
//       return next({ path: target });
//     }
//     return next();
//   };

//   if (!hasPermission) {
//     if (to.path.startsWith('/admin')) {
//       if (!token) {
//         return safeRedirect('/admin/login');
//       } else {
//         return safeRedirect('/no-autorizado');
//       }
//     }
//     return safeRedirect('/home');
//   }

//   if (to.meta.redirectIfAuth && token) {
//     const userData = getUserData();
//     const destino = redireccionPorRol(userData?.roles?.[0]?.nombre);
//     return safeRedirect(destino);
//   }

//   return next();
// });

// tercero

// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem("token");
//   const hasPermission = canNavigate(to);

//   // Caso: usuario no tiene permiso
//   if (!hasPermission) {
//     if (to.path.startsWith("/admin")) {
//       if (!token) {
//         // Redirige a login si no está logueado
//         if (to.path !== "/admin/login") return next({ path: "/admin/login" });
//         return next();
//       } else {
//         // Logueado pero sin permisos -> no autorizado
//         if (to.path !== "/no-autorizado") return next({ path: "/no-autorizado" });
//         return next();
//       }
//     } else {
//       // Rutas públicas donde no tiene permiso
//       if (to.path !== "/home") return next({ path: "/home" });
//       return next();
//     }
//   }

//   // Caso: usuario logueado intentando entrar a ruta pública tipo login
//   if (to.meta.redirectIfAuth && token) {
//     const userData = getUserData();
//     const destino = redireccionPorRol(userData?.roles?.[0]?.nombre);
//     if (to.path !== destino) return next({ path: destino });
//     return next();
//   }

//   // Todo ok, continuar
//   return next();
// });


// cuarto

// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem("token");
//   const hasPermission = canNavigate(to);

//   // Usuario sin permisos
//   if (!hasPermission) {
//     if (to.path.startsWith("/admin")) {
//       // No logueado
//       if (!token) {
//         return next({ path: "/admin/login" });
//       }
//       // Logueado pero sin permiso
//       return next({ path: "/no-autorizado" });
//     } else {
//       // Rutas públicas donde no tiene permiso
//       return next({ path: "/home" });
//     }
//   }

//   // Usuario logueado intentando acceder a ruta pública tipo login
//   if (to.meta.redirectIfAuth && token) {
//     const userData = getUserData();
//     const destino = redireccionPorRol(userData?.roles?.[0]?.nombre);
//     return next({ path: destino });
//   }

//   // Todo ok, continuar a la ruta
//   return next();
// });



// cinco:

// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem("token");
//   const hasPermission = canNavigate(to);

//   // Caso: usuario no tiene permiso
//   if (!hasPermission) {
//     if (to.path.startsWith("/admin")) {
//       if (!token) {
//         // No logueado → login
//         if (to.path !== "/admin/login") return next({ path: "/admin/login" });
//         return next(); // ya estamos en login
//       } else {
//         // Logueado pero sin permiso → no autorizado
//         if (to.path !== "/no-autorizado") return next({ path: "/no-autorizado" });
//         return next(); // ya estamos en no autorizado
//       }
//     } else {
//       // Ruta pública donde no tiene permiso → home
//       if (to.path !== "/home") return next({ path: "/home" });
//       return next();
//     }
//   }

//   // Caso: usuario logueado intentando ir a login
//   if (to.meta.redirectIfAuth && token) {
//     const userData = getUserData();
//     const destino = redireccionPorRol(userData?.roles?.[0]?.nombre);
//     if (to.path !== destino) return next({ path: destino });
//     return next(); // ya estamos en destino
//   }

//   // Todo ok → continuar
//   return next();
// });















































// router.beforeEach((to, from, next) => {
//   let token = localStorage.getItem("token");

//   // Aquí invoca la función canNavigate y almacena el resultado
//   const hasPermission = canNavigate(to);

//   console.log("to", to);
//   console.log("canNavigate de index", hasPermission);

//   if (!hasPermission) {
//     // console.log("NO TENGO PERMISOS");
//     // if (!token) {
//     //   return next({ name: 'Login' });
//     // }

//     // window.location.href = "/no-autorizado"

//     return next({ path: '/about' });

//   } else {
//     console.log("Tiene canNavigate");

//     if (to.meta.redirectIfAuth && token) {
//       const userData = getUserData();
//       console.log(userData.roles[0].nombre);
//       return next(redireccionPorRol(userData ? userData.roles[0].nombre : null));
//     }
//     return next();
//   }
// });





















// router.beforeEach((to, from, next) => {
//   let token = localStorage.getItem("token");

//   console.log("to");
//   console.log(to);
//   console.log("canNavigate de index");
//   console.log(canNavigate(to));  // Invoca la función canNavigate con 'to'

//   if (!canNavigate(to)) {
//     console.log("NO TENGO PERMISOS");
//     if (!token) {
//       return next({ name: 'Login' });
//     }
//     // si NO tengo permisos
//     return next({ name: 'NoAutorizado' });
//   } else {
//     console.log("tiene canNavigate");

//     if (to.meta.redirectIfAuth && token) {
//       const userData = getUserData();
//       console.log(userData.roles[0].nombre);
//       return next(redireccionPorRol(userData ? userData.roles[0].nombre : null));
//     }
//     return next();
//   }
// });


//  La anteultka

// router.beforeEach((to, from, next) => {
//   let token = localStorage.getItem("token")

//   console.log("to")
//   console.log(to)
//   console.log("canNavigate de index")
//   console.log(canNavigate)

//   if(!canNavigate(to)){
//     console.log("NO TENGO PERMISOS");
//     if(!token){
//       return next({name: 'Login'})
//     }
//     // si NO tengo permisos
//     return next({name: 'NoAutorizado'});
//   }else{

//     console.log("tiene canNavigate");

//     if(to.meta.redirectIfAuth && token){
//       const userData = getUserData();
//       console.log(userData.roles[0].nombre);
//       return next(redireccionPorRol(userData?userData.roles[0].nombre:null))
//     }
//     return next();


//   }


// });


//////////////////////////////////////////////////////

// router.beforeEach((to, from, next) => {
//   let token = localStorage.getItem("token")

//   if(to.meta.requireAuth){

//     if(!token){
//       return next({name: "Login"});
//     }
//     return next();
//   }

//   if(to.meta.redirectIfAuth && token){
//     return next({name: "admin"});
//     //     const userData = getUserData();
//     //     console.log(userData.roles[0].nombre);
//     //     return next(redireccionPorRol(userData?userData.roles[0].nombre:null))
//     //   }
//   }

//   return next();

// });


// router.beforeEach((to, from, next) => {
//   let token = localStorage.getItem("token")

//   console.log(to)

//   if(!canNavigate(to)){
//     console.log("NO TENGO PERMISOS");
//     if(!token){
//       return next({name: 'Login'})
//     }
//     // si NO tengo permisos
//     return next({name: 'NoAutorizado'});
//   }

//   if(to.meta.redirectIfAuth && token){
//     const userData = getUserData();
//     console.log(userData.roles[0].nombre);
//     return next(redireccionPorRol(userData?userData.roles[0].nombre:null))
//   }
//   return next();

// });



export default router
